/**
 * @generated SignedSource<<cf9dd52bff7eb700bc199213f93ee422>>
 * @relayHash 68742a61b838212a798006d6e9c7143f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery$variables = {
  first?: number | null | undefined;
  schemeId: string;
};
export type mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery$data = {
  readonly jira: {
    readonly getProjectsByPermissionScheme: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly projectId: string;
        };
      } | null | undefined>;
    };
    readonly viewPermissionScheme: {
      readonly configuration?: {
        readonly isEditable: boolean;
      };
      readonly " $fragmentSpreads": FragmentRefs<"PermissionCategories" | "header_editPermissionScheme">;
    };
  } | null | undefined;
};
export type mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery = {
  response: mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery$data;
  variables: mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider": supportTeams_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider: {
    readonly get: () => boolean;
  };
});

import supportTeams_provider from '@atlassian/jira-relay-provider/src/jira-project-permission-support-teams.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemeId"
},
v2 = {
  "kind": "Variable",
  "name": "schemeId",
  "variableName": "schemeId"
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "name": "isEditable"
},
v5 = {
  "concreteType": "JiraPermissionSchemeConfiguration",
  "kind": "LinkedField",
  "name": "configuration",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ]
},
v6 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v2/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "kind": "ScalarField",
  "name": "description"
},
v12 = {
  "kind": "ScalarField",
  "name": "text"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v3/*: any*/),
              "kind": "LinkedField",
              "name": "viewPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PermissionCategories"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "header_editPermissionScheme"
                    },
                    (v5/*: any*/)
                  ],
                  "type": "JiraPermissionSchemeView"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.viewPermissionScheme"
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": (v6/*: any*/),
              "concreteType": "JiraProjectConnection",
              "kind": "LinkedField",
              "name": "getProjectsByPermissionScheme",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraProject",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v7/*: any*/),
                              "action": "LOG",
                              "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                            }
                          ]
                        },
                        "action": "LOG",
                        "path": "jira.getProjectsByPermissionScheme.edges.node"
                      }
                    ]
                  },
                  "action": "LOG",
                  "path": "jira.getProjectsByPermissionScheme.edges"
                }
              ]
            },
            "action": "LOG",
            "path": "jira.getProjectsByPermissionScheme"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "viewPermissionScheme",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraPermissionSchemeGrantGroup",
                    "kind": "LinkedField",
                    "name": "grantGroups",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPermissionCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraPermissionGrantHolder",
                        "kind": "LinkedField",
                        "name": "grantHolders",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraProjectPermission",
                            "kind": "LinkedField",
                            "name": "permission",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v11/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionConfiguration",
                            "kind": "LinkedField",
                            "name": "configuration",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "tag"
                              },
                              {
                                "concreteType": "JiraPermissionMessageExtension",
                                "kind": "LinkedField",
                                "name": "message",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionDocumentationExtension",
                                "kind": "LinkedField",
                                "name": "documentation",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraPermissionGrants",
                            "kind": "LinkedField",
                            "name": "grants",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraGrantTypeKey",
                                "kind": "LinkedField",
                                "name": "grantType",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraPermissionGrantValue",
                                "kind": "LinkedField",
                                "name": "grantValues",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v9/*: any*/)
                                        ],
                                        "type": "JiraDefaultGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v14/*: any*/)
                                          }
                                        ],
                                        "type": "JiraUserGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraGroup",
                                            "kind": "LinkedField",
                                            "name": "group",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "usageType"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "avatarUrl"
                                                  }
                                                ]
                                              },
                                              (v13/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraGroupGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraRole",
                                            "kind": "LinkedField",
                                            "name": "role",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v13/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraProjectRoleGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "field",
                                            "plural": false,
                                            "selections": (v14/*: any*/)
                                          }
                                        ],
                                        "type": "JiraIssueFieldGrantTypeValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v13/*: any*/)
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      }
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "totalCount"
                              },
                              (v8/*: any*/)
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraPermissionScheme",
                    "kind": "LinkedField",
                    "name": "scheme",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ],
                "type": "JiraPermissionSchemeView"
              }
            ]
          },
          {
            "args": (v6/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "getProjectsByPermissionScheme",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9dd26f13d3fb1b9e1841f3a7c158f1280d92df4a0e3f0e04a02484bf36dbae88",
    "metadata": {},
    "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraprojectpermissionsupportteamsrelayprovider": supportTeams_provider
    }
  }
};
})();

(node as any).hash = "9e1e7326d79aae057f4943753d3cd309";

export default node;
